import axiosInstance from "../../../../Shared/Utils/axiosInstance";
import { DistrictApi } from "../../../../Shared/Constants/api";
import { getDistrictCreationObject } from "../Data/DistrictWrappers";

export const createDistrictApi = async (data) => {
  try {
    let response = await axiosInstance.post(
      `${DistrictApi}`,
      getDistrictCreationObject(data)
    );

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
